// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".maintenance-banner[data-v-19cb1871]{align-items:center;display:flex;font-weight:400;justify-content:center;padding:4px;position:relative;text-align:center;z-index:20}.maintenance-banner[data-v-19cb1871] a{-webkit-text-decoration:underline;text-decoration:underline}@media(max-width:576px){.maintenance-banner span[data-v-19cb1871]{transform:scale(.9)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
